import type { ReactElement } from 'react';
import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { ContractDetailPage } from './ContractDetailPage';
import { ContractFormPage } from './ContractFormPage';
import { ContractsPage } from './ContractsPage';
import { TerminationDetailPage } from './TerminationDetailPage';
import { TerminationFormPage } from './TerminationFormPage';

export { PublicContractPage } from './PublicContractPage';
export { PublicTerminationPage } from './PublicTerminationPage';

const gate = (permission: string, element: ReactElement) => <ModuleGate module="contracts" permission={permission}>{element}</ModuleGate>;

/** Einstiegspunkt des Moduls Verträge im Backoffice (Schlüssel `contracts`, siehe docs/vertraege.md) unter /vertraege. Die öffentliche Seite zum Unterschreiben (/vertrag/:token) hängt in main.tsx. */
export const contractsModule: BackofficeModule = {
  key: 'contracts',
  path: '/vertraege',
  nav: [{ label: 'Verträge', path: '/vertraege' }],
  routes: (
    <>
      <Route path="vertraege" element={gate('contracts.read', <ContractsPage />)} />
      <Route path="vertraege/neu" element={gate('contracts.write', <ContractFormPage />)} />
      <Route path="vertraege/:id" element={gate('contracts.read', <ContractDetailPage />)} />
      <Route path="vertraege/:id/bearbeiten" element={gate('contracts.write', <ContractFormPage />)} />
      <Route path="vertraege/:id/kuendigung/neu" element={gate('contracts.write', <TerminationFormPage />)} />
      <Route path="vertraege/:id/kuendigung/:tid" element={gate('contracts.read', <TerminationDetailPage />)} />
      <Route path="vertraege/:id/kuendigung/:tid/bearbeiten" element={gate('contracts.write', <TerminationFormPage />)} />
    </>
  ),
};
